
import Vue from "vue";
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
  factory,
  ResultError,
  SysAdminPrintBackgroundTemplatesClient,
  UpsertPrintBackgroundTemplateRequest,
} from "@/api-client";
import toasts from "@/components/Toasts";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import { Route } from "vue-router";
import { Prop } from "vue-property-decorator";
import ErrorsSummary from "@/components/ErrorsSummary.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import Loader from "@/features/shared/components/Loader";

interface Props {
  preloadedModel?: UpsertPrintBackgroundTemplateRequest;
  backFileUrl?: string | null;
  frontFileUrl?: string | null;
}

@Component({
  components: {
    HeadingWave,
    LabelOptional,
    AdministrationDetailviewLayout,
    ErrorsSummary,
    ImageUploader,
  },
})
export default class UpsertPrintBackgroundTemplate extends Vue {
  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    const props = to.meta!.props as Props;
    try {
      if (to.params.id) {
        const templateToUpdate = await new SysAdminPrintBackgroundTemplatesClient().details(
          to.params.id
        );

        const files = await new SysAdminPrintBackgroundTemplatesClient().downloadFile(
          to.params.id
        );

        props.backFileUrl = files.backFile;
        props.frontFileUrl = files.frontFile;

        props.preloadedModel = new UpsertPrintBackgroundTemplateRequest({
          id: templateToUpdate.id,
          name: templateToUpdate.name,
          backFile: [],
          frontFile: [],
        });
      }

      next();
    } catch (e) {
      next(e);
    }
  }

  @Prop({
    required: false,
    default: () => factory.create(UpsertPrintBackgroundTemplateRequest),
  })
  preloadedModel!: UpsertPrintBackgroundTemplateRequest;

  @Prop({ required: false })
  frontFileUrl?: string | null;
  @Prop({ required: false })
  backFileUrl?: string | null;

  model = this.preloadedModel;
  fileLoader = new Loader();

  validationErrors: ResultError = ResultError.createEmpty();

  async save() {
    this.validationErrors = ResultError.createEmpty();
    await new SysAdminPrintBackgroundTemplatesClient()
      .setLoader(this.fileLoader)
      .upsert(this.model)
      .then(
        () => {
          this.$router.push({ name: "print-background-templates" });
          toasts.success(
            this.$ls.Administration_PrintBackground_Toasts_SuccessfullySaved
          );
        },
        (errorResponse: ResultError) => {
          this.validationErrors = errorResponse;
          toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
        }
      );
  }


  async remove() {
    this.validationErrors = ResultError.createEmpty();
    if(!this.model.id) return;
    await new SysAdminPrintBackgroundTemplatesClient()
      .delete(this.model.id)
      .then(
        () => {
          this.$router.push({ name: "print-background-templates" });
          toasts.success(
            this.$ls.Global_Deleted
          );
        },
        (errorResponse: ResultError) => {
          this.validationErrors = errorResponse;
          toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
        }
      );
  }

  uploadNewCustomFrontFile(event: Event) {
    event.preventDefault();
    this.frontFileUrl = null;
    this.model.frontFile = [];
  }

  uploadNewCustomBackFile(event: Event) {
    event.preventDefault();
    this.backFileUrl = null;
    this.model.backFile = [];
  }
}
